import { render, staticRenderFns } from "./feedbackDetailedInfo.vue?vue&type=template&id=03b16728&"
import script from "./feedbackDetailedInfo.vue?vue&type=script&lang=js&"
export * from "./feedbackDetailedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports